import React from 'react';
import "react-table/react-table.css";
import { Card, Header, Grid, Menu} from 'semantic-ui-react';
import { pipe, prop, groupBy, toPairs, map, mapObjIndexed, sortBy } from 'ramda';
import { generate } from 'shortid';


const TeamCard = (props) => {
  //const { name, robotNumber, robotName } = props.data;
  const { robotNumber } = props.data;

  return (
    <Menu fluid vertical>
      <Menu.Item className='header'>{robotNumber}</Menu.Item>
      {/* <Menu.Item>{robotName}</Menu.Item> */}
      {/* <Menu.Item>{name}</Menu.Item> */}
    </Menu>
  );
};

// TODO make sure that match cannot have more than 2 participants!
const MatchCard = (props) => {
  const [t1, t2] = props.data;

  //console.log( props ); 

  return (
    <Card style={{ 'boxShadow': 'none' }}>
      <Card.Content>
        <Card.Description>
          <Grid textAlign='center' columns={t2 ? 3 : 1}>
            {t2 && 
             <Grid.Row style={{ 'paddingBottom': 0 }}>
               <Grid.Column width={7}>
                 <TeamCard data={t1}/>
               </Grid.Column>
               <Grid.Column width={2}>
                 <Menu fluid vertical text>
                   <Menu.Item className='header'>VS</Menu.Item>
                 </Menu>
               </Grid.Column>
               <Grid.Column width={7}>
                 <TeamCard data={t2}/>
               </Grid.Column>
             </Grid.Row>}
            {!t2 &&
             <Grid.Row style={{ 'paddingBottom': 0 }}>
               <Grid.Column width={7}>
                 <TeamCard data={t1}/>
               </Grid.Column>
             </Grid.Row>}
          </Grid>
        </Card.Description>
      </Card.Content>
      <Card.Content extra textAlign='center'>
        G:{props.group}, R:{props.attempt}, ID:{props.matchId}
      </Card.Content>
    </Card> 
  );
};

const AttemptCard = (props) => {
  const data = pipe(
    groupBy(prop('matchId')),
    mapObjIndexed((value, key) =>
                  <MatchCard
                    key={generate()}
                    group={props.group}
                    attempt={props.attempt}
                    matchId={key}
                    data={value}/>),
    toPairs()
  )(props.data || []);

  return map(([match, matchCards]) => matchCards, data);
};

const GroupCard = (props) => {
  const data = pipe(
    groupBy(prop('attempt')),
    mapObjIndexed((value, key) =>
                  <AttemptCard
                    key={generate()}
                    group={props.group}
                    attempt={key}
                    data={value}/>),
    toPairs()
  )(props.data || []);

  //console.log( props.data );

  return (
    <Card.Group>
      {map(([attempt, attemptCards]) => attemptCards, data)}
    </Card.Group>
  );
};


const TimeCard = (props) => {
  const data = pipe(
    groupBy(prop('group')),
    mapObjIndexed((value, key) => <GroupCard key={generate()} group={key} data={value}/>),
    toPairs()
  )(props.data || []);

  return (
    <Grid.Row>
      <Grid.Column width={2}>
        <Header as='h3' content={props.time}/>
      </Grid.Column>
      <Grid.Column width={14}>
        {map(([group, groupCards]) => groupCards, data)}
      </Grid.Column>
    </Grid.Row>
  );
};

const Timetable = (props) => {
  const data = pipe(
    sortBy(prop('beginTime')),
    groupBy(prop('beginTime')),
    mapObjIndexed((value, key) => <TimeCard key={generate()} time={key} data={value}/>),
    toPairs()
  )(props.data || []);

  //style={{ 'font-size': '50%' }}
  return (
    <Grid columns={2}>
      {map(([time, timeCards]) => timeCards, data)}
    </Grid>
  );
};

export default Timetable;



// WEBPACK FOOTER //
// ./src/private/common/components/Tournament/Tables/Timetable/index.js